module.exports = __webpack_public_path__ + "static/media/ui-design-process-flow.a93ccb69.png";